// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__MjS6Z","elements":"Footer_elements__TQ1ui","footer_title":"Footer_footer_title__+3sSP","dev":"Footer_dev__Vk+hY"};